"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.popperPlacementInputNoBorder = exports.popperPlacementPopperNoRadius = exports.popperPlacementInputNoRadius = exports.addPopperPositionClassPopperModifier = exports.setPopperPlacementAttribute = exports.popperPlacementSelectors = void 0;
const popperPositionDataAttribute = "data-popper-placement";
exports.popperPlacementSelectors = {
    top: `[${popperPositionDataAttribute}="top"]`,
    bottom: `[${popperPositionDataAttribute}="bottom"]`,
    topStart: `[${popperPositionDataAttribute}="top-start"]`,
    topEnd: `[${popperPositionDataAttribute}="top-end"]`,
    bottomStart: `[${popperPositionDataAttribute}="bottom-start"]`,
    bottomEnd: `[${popperPositionDataAttribute}="bottom-end"]`,
};
const setPopperPlacementAttribute = (node, placement) => {
    node.setAttribute(popperPositionDataAttribute, placement);
};
exports.setPopperPlacementAttribute = setPopperPlacementAttribute;
exports.addPopperPositionClassPopperModifier = {
    name: "addPositionSelector",
    enabled: true,
    phase: "write",
    fn({ state, options }) {
        if (state.elements.reference instanceof HTMLElement) {
            (0, exports.setPopperPlacementAttribute)(state.elements.reference, state.placement);
        }
        // This allows a consumer to be notified when the placement has changed
        const { update } = options;
        if (typeof update === "function") {
            update(state.placement);
        }
    },
};
exports.popperPlacementInputNoRadius = {
    [`&${exports.popperPlacementSelectors.bottom}, &${exports.popperPlacementSelectors.bottomStart}, ${exports.popperPlacementSelectors.bottom} &, ${exports.popperPlacementSelectors.bottomStart} &`]: {
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
    },
    [`&${exports.popperPlacementSelectors.top}, &${exports.popperPlacementSelectors.topStart}, ${exports.popperPlacementSelectors.top} &, ${exports.popperPlacementSelectors.topStart} &`]: {
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
    },
};
exports.popperPlacementPopperNoRadius = {
    [`&${exports.popperPlacementSelectors.top}, &${exports.popperPlacementSelectors.topStart}, ${exports.popperPlacementSelectors.top} &, ${exports.popperPlacementSelectors.topStart} &`]: {
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
    },
    [`&${exports.popperPlacementSelectors.bottom}, &${exports.popperPlacementSelectors.bottomStart}, ${exports.popperPlacementSelectors.bottom} &, ${exports.popperPlacementSelectors.bottomStart} &`]: {
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
    },
};
exports.popperPlacementInputNoBorder = {
    [`&${exports.popperPlacementSelectors.bottom}`]: {
        borderBottom: 0,
    },
    [`&${exports.popperPlacementSelectors.top}`]: {
        borderTop: 0,
    },
};
